import React from "react";
import { Briefcase, MapPin } from "lucide-react";

const JobPositionCard = ({ data = [], selectedId, onSelect }) => {
  return (
    <>
      {data.map((job) => {
        const { jpo_id, jpo_title, department_name, location_name } = job;
        const isSelected = selectedId === jpo_id;

        return (
          <div
            key={jpo_id}
            onClick={() => onSelect(jpo_id)}
            className={`p-3 w-full rounded-lg cursor-pointer transition-all border-2
              ${
                isSelected
                  ? "bg-gradient-to-r from-purple-100 to-emerald-100 border-purple-300"
                  : "bg-gray-50 border-gray-50 hover:bg-gray-100 hover:border-purple-200"
              }
            `}
          >
            <span
              className={`font-medium ${
                isSelected ? "text-purple-900" : "text-gray-900"
              }`}
            >
              {jpo_title}
            </span>

            <div className="flex flex-col mt-1">
              <span className="flex items-center gap-1 text-xs text-gray-800">
                <Briefcase className="w-3 h-3" />
                {department_name}
              </span>
              <span className="flex items-center gap-1 text-xs text-gray-800">
                <MapPin className="w-3 h-3" />
                {location_name}
              </span>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default JobPositionCard;
